import React, { useState, useEffect } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import './Lightbox.css';

// Popup a pantalla completa para ver fotos en grande y navegar entre ellas.
const Lightbox = ({ images, index = 0, onClose }) => {
  const [idx, setIdx] = useState(index);
  const multiple = images.length > 1;

  useEffect(() => setIdx(index), [index]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowLeft') setIdx((i) => (i - 1 + images.length) % images.length);
      else if (e.key === 'ArrowRight') setIdx((i) => (i + 1) % images.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [images.length, onClose]);

  const go = (e, dir) => {
    e.stopPropagation();
    setIdx((i) => (i + dir + images.length) % images.length);
  };

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <button type="button" className="lightbox-close" onClick={onClose} aria-label="Cerrar">
        <CloseIcon sx={{ fontSize: 28 }} />
      </button>
      {multiple && (
        <button type="button" className="lightbox-nav prev" onClick={(e) => go(e, -1)} aria-label="Anterior">
          <ArrowBackIosNewIcon sx={{ fontSize: 22 }} />
        </button>
      )}
      <img className="lightbox-img" src={images[idx]} alt="" onClick={(e) => e.stopPropagation()} />
      {multiple && (
        <button type="button" className="lightbox-nav next" onClick={(e) => go(e, 1)} aria-label="Siguiente">
          <ArrowForwardIosIcon sx={{ fontSize: 22 }} />
        </button>
      )}
      {multiple && <span className="lightbox-counter">{idx + 1} / {images.length}</span>}
    </div>
  );
};

export default Lightbox;
